import { useCallback } from 'react';
import useSWR from 'swr';
import { CACHE_KEYS } from '../utils/CacheUtils.js';
/**
 * @param client
 * @param query If `undefined`, no data is fetched
 * @param options
 */
export function useAdminEntitiesSample(client, query, options) {
    const fetcher = useCallback(([_action, query, options]) => fetchSampleEntities(client, query, options), [client]);
    const { data, error } = useSWR(query ? CACHE_KEYS.adminEntitiesSample(query, options) : null, fetcher);
    // useDebugLogChangedValues('useAdminEntitiesSample updated values', {
    //   client,
    //   query,
    //   options,
    //   data,
    //   error,
    // });
    return { entitiesSample: data, entitiesSampleError: error };
}
async function fetchSampleEntities(client, query, options) {
    const result = await client.getEntitiesSample(query, options);
    if (result.isError()) {
        throw result; // throw result, don't convert to Error
    }
    return result.value;
}
//# sourceMappingURL=useAdminEntitiesSample.js.map